export default "__VITE_ASSET__CflF5yAO__"